import React, {Fragment} from 'react';

import {gt} from 'app/utils/i18n';

import {ViewModeTitle} from './ViewModeTitle';

type Props = {
  title?: string;
  numCollapsedSteps?: number;
  toggleAllStepsCollapse?: (arg0: boolean) => void;
};

export function ViewStepsModeTitle({
  title,
  numCollapsedSteps,
  toggleAllStepsCollapse,
}: Props): JSX.Element {
  return (
    <ViewModeTitle
      title={title || gt('Steps List')}
      actionsBox={
        numCollapsedSteps != null && toggleAllStepsCollapse != null ? (
          <Fragment>
            {numCollapsedSteps != null && numCollapsedSteps > 0 ? (
              <button
                className="btn btn-link text-secondary p-0 d-print-none"
                onClick={() => toggleAllStepsCollapse(false)}
              >
                {gt('Expand All')} <i className="fa fa-chevron-down" />
              </button>
            ) : (
              <button
                className="btn btn-link text-secondary p-0 d-print-none"
                onClick={() => toggleAllStepsCollapse(true)}
              >
                {gt('Collapse All')} <i className="fa fa-chevron-up" />
              </button>
            )}
          </Fragment>
        ) : null
      }
    />
  );
}
